"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidationErrors = exports.EditableLegalConsentKeys = exports.SettingsKeys = exports.LegalConsentKeys = exports.ProcessingConsentTypes = exports.CamelCaseOptions = exports.LegalConsentOptions = exports.LEGAL_CONSENT_SUBMISSION_SUBSCRIPTION_PREFIX_KEY = exports.LEGAL_CONSENT_SUBMISSION_PROCESSING_KEY = exports.LEGAL_CONSENT_VALUES_KEY = exports.LEGAL_CONSENT_OPTIONS_KEY = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _Object$freeze;

var LEGAL_CONSENT_OPTIONS_KEY = 'legalConsentOptions';
exports.LEGAL_CONSENT_OPTIONS_KEY = LEGAL_CONSENT_OPTIONS_KEY;
var LEGAL_CONSENT_VALUES_KEY = 'legalConsentValues';
exports.LEGAL_CONSENT_VALUES_KEY = LEGAL_CONSENT_VALUES_KEY;
var LEGAL_CONSENT_SUBMISSION_PROCESSING_KEY = 'processing';
exports.LEGAL_CONSENT_SUBMISSION_PROCESSING_KEY = LEGAL_CONSENT_SUBMISSION_PROCESSING_KEY;
var LEGAL_CONSENT_SUBMISSION_SUBSCRIPTION_PREFIX_KEY = 'subscription_type_';
exports.LEGAL_CONSENT_SUBMISSION_SUBSCRIPTION_PREFIX_KEY = LEGAL_CONSENT_SUBMISSION_SUBSCRIPTION_PREFIX_KEY;
var LegalConsentOptions = (0, _keyMirror.default)({
  NONE: null,
  IMPLICIT_CONSENT: null,
  SEPERATE_CONSENT: null,
  LEGITIMATE_INTEREST: null
});
exports.LegalConsentOptions = LegalConsentOptions;
var CamelCaseOptions = Object.freeze((_Object$freeze = {}, (0, _defineProperty2.default)(_Object$freeze, LegalConsentOptions.NONE, 'none'), (0, _defineProperty2.default)(_Object$freeze, LegalConsentOptions.IMPLICIT_CONSENT, 'implicitConsent'), (0, _defineProperty2.default)(_Object$freeze, LegalConsentOptions.SEPERATE_CONSENT, 'seperateConsent'), (0, _defineProperty2.default)(_Object$freeze, LegalConsentOptions.LEGITIMATE_INTEREST, 'legitimateInterest'), _Object$freeze));
exports.CamelCaseOptions = CamelCaseOptions;
var ProcessingConsentTypes = (0, _keyMirror.default)({
  IMPLICIT: null,
  REQUIRED_CHECKBOX: null
});
exports.ProcessingConsentTypes = ProcessingConsentTypes;
var LegalConsentKeys = Object.freeze({
  IS_LEGITIMATE_INTEREST: 'isLegitimateInterest',
  COMMUNICATION_CONSENT_TEXT: 'communicationConsentText',
  COMMUNICATION_CONSENT_CHECKBOXES: 'communicationConsentCheckboxes',
  PROCESSING_CONSENT_TYPE: 'processingConsentType',
  PROCESSING_CONSENT_TEXT: 'processingConsentText',
  PROCESSING_CONSENT_CHECKBOX_LABEL: 'processingConsentCheckboxLabel',
  PROCESSING_CONSENT_FOOTER_TEXT: 'processingConsentFooterText',
  PRIVACY_POLICY_TEXT: 'privacyPolicyText',
  SUBSCRIPTION_TYPES: 'legitimateInterestSubscriptionTypes',
  LAWFUL_BASIS: 'legitimateInterestLegalBasis'
});
exports.LegalConsentKeys = LegalConsentKeys;
var SettingsKeys = Object.freeze({
  COMMUNICATION_CONSENT_CHECKBOXES: 'communicationConsentCheckboxes',
  COMMUNICATION_CONSENT_TEXT: 'communicationConsentText',
  EXPLICIT_PROCESSING_CONSENT_CHECKBOX_LABEL: 'explicitProcessingConsentCheckboxLabel',
  EXPLICIT_PROCESSING_CONSENT_TEXT: 'explicitProcessingConsentText',
  IMPLICIT_PROCESSING_CONSENT_TEXT: 'implicitProcessingConsentText',
  LEGITIMATE_INTEREST_PRIVACY_POLICY_TEXT: 'legitimateInterestPrivacyPolicyText',
  PRIVACY_POLICY_TEXT: 'privacyPolicyText'
});
exports.SettingsKeys = SettingsKeys;
var EditableLegalConsentKeys = Object.freeze({
  COMMUNICATION_CONSENT_TEXT: LegalConsentKeys.COMMUNICATION_CONSENT_TEXT,
  COMMUNICATION_CONSENT_CHECKBOXES: LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES,
  PROCESSING_CONSENT_TEXT: LegalConsentKeys.PROCESSING_CONSENT_TEXT,
  PROCESSING_CONSENT_CHECKBOX_LABEL: LegalConsentKeys.PROCESSING_CONSENT_CHECKBOX_LABEL,
  PROCESSING_CONSENT_FOOTER_TEXT: LegalConsentKeys.PROCESSING_CONSENT_FOOTER_TEXT,
  SUBSCRIPTION_TYPES: LegalConsentKeys.SUBSCRIPTION_TYPES,
  LAWFUL_BASIS: LegalConsentKeys.LAWFUL_BASIS,
  PRIVACY_POLICY_TEXT: LegalConsentKeys.PRIVACY_POLICY_TEXT
});
exports.EditableLegalConsentKeys = EditableLegalConsentKeys;
var ValidationErrors = Object.freeze({
  REQUIRED: 'required'
});
exports.ValidationErrors = ValidationErrors;